import FeatureGate from "@/src/components/feature-gate";
import WikiArticlesScreen from "@/src/screens/wiki/wiki-articles-screen/wiki-articles-screen";

export default function WikiArticles() {
  return (
    <FeatureGate feature="wiki">
      <WikiArticlesScreen />
    </FeatureGate>
  );
}
